import { Component, Vue, PropSync, Prop, Watch, Inject } from 'vue-property-decorator';
import DsModal from '@/shared/modal/ds-modal.vue';
import { Channel } from '@/shared/model/scrap-agent.model';
import VueCustomScrollbar from 'vue-custom-scrollbar/src/vue-scrollbar.vue';
import ScrapAgentService from '@/service/scrap-agent.service';
import { namespace } from 'vuex-class';
import WebsocketService from '@/service/websocket.service';
import { AccountChannel } from '@/shared/model/collection-channel.model';

interface AppInfo {
  redirectUrl: string;
  clientId: string;
  scope: string;
  appId: number;
  clientSecret: string;
}

const appStoreState = namespace('appStore');

@Component({
  components: { DsModal, VueCustomScrollbar },
})
export default class ChannelsRegisterCommon extends Vue {
  @PropSync('listChannel', { type: Array })
  listChannelRegister!: AccountChannel[];
  @Prop({ type: Object, required: false }) itemSetting!: any;
  @Prop({ type: Boolean, required: false }) scrollTop!: boolean;

  @Inject('scrapAgentService')
  public scrapAgentService: () => ScrapAgentService;
  @Inject('websocketService')
  private websocketService: () => WebsocketService;

  @Prop({ type: Array, default: () => [] })
  listAgent!: string[];
  appInfo: AppInfo | null = null;
  channelRegisterFirst: AccountChannel | null = null;
  authState = '';
  item = null;
  messageProcessed = false;
  isShowFullMap: Record<string, boolean> = {};
  scrollSettings = { wheelPropagation: false };
  formData = {
    briefingPrivacy: this.itemSetting?.privacy || 'PRIVATE',
  } as any;

  @Prop({ type: Boolean, default: false }) isShowTab!: boolean;

  @appStoreState.Getter
  public isShowCreateBriefing!: boolean;

  @Watch('formData', { deep: true })
  onFormDataChange(value: any) {
    this.$emit('briefingPrivacy', value);
    console.log(this.itemSetting, 'this.itemSetting');
  }

  @Watch('scrollTop', { deep: true })
  onScrollTop(value: boolean) {
    if (value) {
      this.scrollToTop();
    }
  }

  @Watch('listChannelRegister', { deep: true, immediate: true })
  onFormDataStep2Change(): void {
    if (this.listChannelRegister) {
      this.$emit('listChannelRegister', this.listChannelRegister);
    }
  }

  isAllScrap(accounts) {
    return accounts.every(acc => acc.isScrap);
  }

  toggleAllScrap(item, event) {
    const checked = event.target.checked;
    item.collections.forEach(acc => {
      this.$set(acc, 'isScrap', checked);
    });
  }

  async handleDeleteScrapAgent(item: any, collection: any) {
    // console.log(this.listChannelRegister, "this.listChannelRegister");
    const payload = {
      ...item,
      collections: [collection],
    };
    this.$emit('deleteScrapAgent', payload);
  }

  getAccountName(item: any): string {
    if (item.channelType === 'FACEBOOK') {
      return item.fullname || item.fullName;
    }
    return item.accountId && item.accountName ? item.accountName : item.channelNameEn;
  }

  channelName(item: any) {
    const isShow = item.accountId && item.accountName;
    return {
      name: item.channelNameEn,
      isShow: isShow,
    };
  }

  notAliveToken(item: any) {
    return item.isAliveAccount == false;
  }

  onChangeScrap(item, selectedIndex, isChecked) {
    item.collections.forEach((col, idx) => {
      if (idx === selectedIndex) {
        col.isScrap = isChecked;
      }
    });
  }

  titleDatasource(item: any) {
    const title = item.descriptionEn ? item.descriptionEn : item.dataSourceTypes[0];
    return item.datasourceValue || item.value ? title + ': ' : title;
  }

  genIdDatasource(item: any) {
    return item.accountId || item.value || '-';
  }

  valueDatasource(item: any) {
    if (item.value && item.value.length > 0) {
      return item.value.join(', ');
    }
    return '';
  }

  changeStatus(item: any, indexAcc: number, index: number) {
    const updatedData = JSON.parse(JSON.stringify(this.listChannelRegister));
    const channelIndex = updatedData.findIndex(
      channel =>
        channel === item ||
        (channel.channelId && item.channelId && channel.channelId === item.channelId) ||
        (channel.channelName && item.channelName && channel.channelName === item.channelName)
    );

    if (channelIndex === -1) {
      console.error('Channel not found', item);
      return;
    }

    if (!updatedData[index].accounts) {
      updatedData[index].accounts = [{ isScrap: false }];
    } else if (updatedData[index].accounts.length === 0) {
      updatedData[index].accounts.push({ isScrap: false });
    }

    // Toggle the isScrap property
    if (updatedData[index].accounts[indexAcc]) {
      updatedData[index].accounts[indexAcc].isScrap = !updatedData[index].accounts[indexAcc].isScrap;
    }

    // Update the data
    this.listChannelRegister = updatedData;
  }

  highLightElement(item: any) {
    if (Array.isArray(item.collections)) {
      const hasScrap = item.collections.some(account => account.isScrap === true);
      return hasScrap ? 'high-light' : '';
    }
    return '';
  }

  handleSetting(item: any, collection: any) {
    collection.isSetting = true;
    if (this.itemSetting) {
      const payload = {
        ...item,
        collections: [collection],
      };
      this.$emit('channelSetting', payload);
    }
  }

  handleEditDatasource(collection: any) {
    if (this.itemSetting) {
      // if (collection.bpId == null || collection.bpId === this.itemSetting.bpId) {
      if (collection.bpId === this.itemSetting.bpId) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  isMailChannel(item: any) {
    const mailChannel = ['GMAIL', 'DAUM', 'NAVER_MAIL', 'NAVER', 'OUTLOOK', 'YAHOO'];
    if (mailChannel.includes(item.channelNameEn)) {
      return true;
    } else {
      return false;
    }
  }

  isOauthAccount(item: any) {
    const oauthProviders = [
      'YOUTUBE',
      'GOOGLE_DRIVE',
      'ONE_DRIVE',
      'FACEBOOK',
      'X_TWITTER',
      'DROP_BOX',
      'GMAIL',
      'OUTLOOK',
      'WORDPRESS',
      'BRUNCH',
      'NAVER_BLOG',
      'NAVER',
      'DAUM',
      'NAVER_MAIL',
    ];
    return oauthProviders.includes(item.channelType);
  }

  async handleUpdateAccount(item: any) {
    console.log(item, 'item');
    this.item = item;
    const oauthGoogle = ['YOUTUBE', 'GOOGLE_DRIVE', 'GMAIL'];
    const oauthMicrosoft = ['ONE_DRIVE', 'OUTLOOK'];
    const accountLogin = ['BRUNCH', 'NAVER_BLOG', 'NAVER', 'DAUM', 'NAVER_MAIL'];
    if (accountLogin.includes(item.channelType)) {
      this.$emit('openLoginAccount', item);
      return;
    }
    await this.scrapAgentService()
      .getAppInfo(item.channelType)
      .then((result: any) => {
        if (result && result.body && result.body.length > 0) {
          this.appInfo = {
            appId: result.body[0].appId,
            redirectUrl: result.body[0].redirectUrl,
            clientId: result.body[0].clientId,
            scope: result.body[0].scope,
            clientSecret: result.body[0].clientSecret,
          };
        }
      })
      .catch(error => {
        console.error('Failed to fetch app info:', error);
      });
    this.messageProcessed = false;
    window.removeEventListener('message', this.receiveMessage);
    window.addEventListener('message', this.receiveMessage, false);
    if (oauthGoogle.includes(item.channelType)) {
      this.handleReAuthorGoogle(item);
    } else if (oauthMicrosoft.includes(item.channelType)) {
      this.handleReAuthorMicrosoft(item);
    } else if (item.channelType === 'X_TWITTER') {
      this.handleReAuthorX(item);
    } else if (item.channelType === 'FACEBOOK') {
      this.handleReAuthorFaceBook(item);
    } else if (item.channelType === 'DROP_BOX') {
      this.handleReAuthorDropBox(item);
    } else if (item.channelType === 'WORDPRESS') {
      this.handleReAuthorWordpress(item);
    }
  }

  generateWindowId(): string {
    return 'id_' + Math.random().toString(36).substr(2, 9);
  }
  scrollToTop() {
    const scrollbarComponent = this.$refs.scrollbarRef as Vue;
    const scrollContainer = scrollbarComponent.$el as HTMLElement;
    if (scrollContainer) {
      scrollContainer.scrollTop = 0;
    }
  }

  handleReAuthorMicrosoft(item: any) {
    const clientId = this.appInfo.clientId;
    this.authState = this.generateWindowId();
    const redirectUrl = window.location.origin + '/api/public/goAuth';
    const loginHint = item.accountName;
    const scope = encodeURIComponent(this.appInfo.scope);
    const authUrl =
      `https://login.microsoftonline.com/common/oauth2/v2.0/authorize` +
      `?response_type=code` +
      `&client_id=${clientId}` +
      `&redirect_uri=${redirectUrl}` +
      `&response_mode=query` +
      `&scope=${scope}` +
      `&login_hint=${loginHint}` +
      `&state=${this.authState}`;
    const popup = window.open(authUrl, 'Microsoft', 'width=600,height=600');
  }

  handleReAuthorGoogle(item: any) {
    const responseType = 'code';
    this.authState = this.generateWindowId();
    const clientId = this.appInfo.clientId;
    const redirectUrl = window.location.origin + '/api/public/goAuth';
    const loginHint = item.accountName;

    const authUrl =
      `https://accounts.google.com/o/oauth2/v2/auth` +
      `?access_type=offline` +
      `&client_id=${clientId}` +
      `&response_type=${responseType}` +
      `&redirect_uri=${redirectUrl}` +
      `&scope=${this.appInfo.scope}` +
      `&state=${this.authState}` +
      `&login_hint=${loginHint}` +
      `&prompt=consent`;

    const popup = window.open(authUrl, 'Google', 'width=600,height=600');
  }

  handleReAuthorX(item: any) {
    const redirectUrl = window.location.origin + '/api/public/goAuth';
    this.authState = this.generateWindowId();
    const clientId = this.appInfo.clientId;
    const authUrl =
      `https://x.com/i/oauth2/authorize` +
      `?response_type=code` +
      `&client_id=${clientId}` +
      `&redirect_uri=${redirectUrl}` +
      `&scope=${this.appInfo.scope}` +
      `&state=${this.authState}` +
      `&code_challenge=ycbxnR_xs-RK8mrNhtv0ZymGWdbNfBn34BuP0N3Deik` +
      `&code_challenge_method=S256`;

    const popup = window.open(authUrl, 'TwitterAuth', 'width=600,height=600');
  }

  handleReAuthorFaceBook(item: any) {
    this.authState = this.generateWindowId();
    const redirectUrl = window.location.origin + '/api/public/goAuth';

    const authUrl =
      `https://www.facebook.com/v22.0/dialog/oauth` +
      `?response_type=code` +
      `&client_id=${this.appInfo.clientId}` +
      `&redirect_uri=${redirectUrl}` +
      `&scope=${encodeURIComponent(this.appInfo.scope)}` +
      `&state=${this.authState}`;
    const popup = window.open(authUrl, 'FaceBook', 'width=600,height=600');
    try {
      const subscription = this.websocketService().subscribeTokenAuth(this.authState, {
        next: authCode => {
          console.log('Received authCode from WebSocket:', authCode);
          this.handleAccountConnect(authCode).then(r => {});
          subscription.unsubscribe();
        },
        error: err => {
          console.error('Error receiving authCode:', err);
        },
      });
    } catch (error) {
      console.error('Error subscribing to authCode channel:', error);
    }
  }

  handleReAuthorDropBox(item: any) {
    this.authState = this.generateWindowId();
    const redirectUrl = window.location.origin + '/api/public/goAuth';

    const clientId = this.appInfo.clientId;
    const authUrl =
      `https://www.dropbox.com/oauth2/authorize` +
      `?response_type=code` +
      `&client_id=${clientId}` +
      `&redirect_uri=${redirectUrl}` +
      `&token_access_type=offline` +
      `&force_reauthentication=true` +
      `&scope=${this.appInfo.scope}` +
      `&state=${this.authState}`;
    const popup = window.open(authUrl, 'DropBox', 'width=600,height=600');
  }

  handleReAuthorWordpress(item: any) {
    this.authState = this.generateWindowId();
    const clientId = this.appInfo.clientId;
    const scope = this.appInfo.scope;
    const redirectUrl = window.location.origin + '/api/public/goAuth';

    const authUrl =
      `https://public-api.wordpress.com/oauth2/authorize` +
      `?client_id=${clientId}` +
      `&redirect_uri=${redirectUrl}` +
      `&response_type=code` +
      `&state=${this.authState}`;
    const popup = window.open(authUrl, 'Wordpress', 'width=600,height=600');
  }

  receiveMessage(event: MessageEvent) {
    if (this.messageProcessed) {
      return;
    }
    // Verify that the message payload contains the expected state and authorization_code.
    if (event.data && event.data.authorization_code && event.data.state === this.authState) {
      this.messageProcessed = true;
      const authCode = event.data.authorization_code;
      console.log('Received matching authorization code:', authCode);
      if (this.item.channelType !== 'FACEBOOK') {
        this.handleAccountConnect(authCode).then(r => {});
      }
    } else {
      this.messageProcessed = false;
      console.warn('Ignoring unexpected message payload:', event.data);
    }
  }

  async handleAccountConnect(authorizationCode: string) {
    const redirectUrl = window.location.origin + '/api/public/goAuth';
    // const payload = {
    //   account_id: this.item.accountId,
    //   api_key: JSON.parse(localStorage.getItem('localStorageUser') || '{}')?.id || null,
    //   channel: this.item.channelType,
    //   avatar: this.item.channelImageUri,
    //   client_id: this.appInfo.clientId,
    //   authorization_code: authorizationCode,
    //   app_id: this.appInfo.appId,
    //   client_secret: this.appInfo.clientSecret,
    //   redirect_uri: redirectUrl,
    //   scope: this.appInfo.scope,
    // };
    const payload = {
      userKey: JSON.parse(localStorage.getItem('localStorageUser') || '{}')?.id || null,
      chanelName: this.item.channelType,
      avatar: this.item.channelImageUri,
      clientId: this.appInfo.clientId,
      authorizationCode: authorizationCode,
      appId: this.appInfo.appId,
      clientSecret: this.appInfo.clientSecret,
      redirectUrl: redirectUrl,
      scope: this.appInfo.scope,
    };
    try {
      const result = await this.scrapAgentService().addUserAccount(payload);
      const responseBody = result?.data?.body?.body?.body;
      // if (!responseBody?.isSuccess) {
      // }
      console.log(responseBody, 'responseBody');
      if (responseBody.accountId != this.item.accountId) {
        this.$bvToast.toast(`${this.$t('scrap-agent.toast.add-account.messReAuFail')}`, {
          toaster: 'b-toaster-bottom-right',
          title: `${this.$t('scrap-agent.toast.add-account.titleReAuFail')}`,
          variant: 'danger',
          solid: true,
          autoHideDelay: 5000,
        });
        return;
      }
      if (result) {
        this.$nextTick(() => {
          this.$bvToast.toast(`${this.$t('scrap-agent.toast.add-account.messReAuSuccess')}`, {
            toaster: 'b-toaster-bottom-right',
            title: `${this.$t('scrap-agent.toast.add-account.titleReAuSuccess')}`,
            variant: 'success',
            solid: true,
            autoHideDelay: 5000,
          });
        });
      }
      const item = {
        account_id: this.item.accountId,
        channel: this.item.channelType,
      };
      this.$emit('ReAuthor', item);
    } catch (error) {
      const detail = error.response?.data?.detail;
      console.error('error: ', detail);
      if (detail) {
        const match = detail.match(/\{"status":(\d+),"message":"(.+?)"}/);
        if (match) {
          const realStatus = parseInt(match[1]);
          const realMessage = match[2];
          if (realMessage) {
            this.$nextTick(() => {
              this.$bvToast.toast(`${this.$t('scrap-agent.toast.add-account.messReAuFail')}`, {
                toaster: 'b-toaster-bottom-right',
                title: `${this.$t('scrap-agent.toast.add-account.titleReAuFail')}`,
                variant: 'danger',
                solid: true,
                autoHideDelay: 5000,
              });
            });
          }
        }
      }
    }
    this.messageProcessed = false;
  }
  toggleShowFull(bpId: string) {
    this.$set(this.isShowFullMap, bpId, !this.isShowFullMap[bpId]);
  }
}
